<template>
  <LayoutPurchase>
    <template slot="purchaseOptions" v-if="persistPurchaseOptions">
      <div 
        class="subscription-container failable loadable" 
        :class="{ 
          failed: countries.error || purchaseOptions.error,
          loading: countries.loading || purchaseOptions.loading || fullLoading
        }"
      >
        <template v-if="!(countries.error || countries.loading || purchaseOptions.error || purchaseOptions.loading)">
          <div v-if="shouldDisplayPlanDescription" class="description-container">
            <h1 class="description">{{ planDescription }}</h1>
          </div>
          <SubscriptionForm
            :selected-country="selectedCountry"
            :purchase-options="purchaseOptions.data"
            :show-currency="showCurrency"
            @loadingChange="fullLoading = $event"
            :code="promotionalCode"
            :referal="referalCode"
            @purchaseOptionSelectedChanged="purchaseOptionSelectedChangedHandler"
          />
        </template>
        <div class="failed-wrapper">
          <p class="error" v-if="countries.error">
            {{$t('error')}}
            <br>
            <button type="button" @click="loadCountries">
              {{$t('retry')}}
            </button>
          </p>
          <p class="error" v-if="purchaseOptions.error">
            {{$t('error')}}
            <br>
            <button type="button" @click="loadPurchaseOptions">
              {{$t('retry')}}
            </button>
          </p>
        </div>
        <div class="loader-wrapper">
          <Spinner/>
        </div>
      </div>
    </template>
    <template slot="purchasePromotionCode">
      <form
              v-show="!promotionalCodeHidden"
              v-if="!countries.error && !countries.loading"
              class="promotional-code-form"
              @submit.prevent="enterPromotionalCode"
              @click="$refs.codeInput.focus()"
              @mouseenter="$refs.codeInput.focus()"
      >
        <label>
          {{$t('subscription.promotional_code.call_to_action.use')}}
        </label>
        <input ref="codeInput" type="text" :class="{'not-empty': !!promotionalCodeTyped}" v-model="promotionalCodeTyped"/>
      </form>
    </template>

    <template slot="disclaimers">
      <section class="disclaimers">
        <router-link :to="{name: 'home'}">
          <div class="logo"></div>
        </router-link>
        <h4>
          * {{$t('subscription.payment_legals.title')}}
        </h4>
        <div class="list" v-if="showCurrency">
          <PurchaseOptionLegals
                  :show-currency="showCurrency"
                  :purchase-option="purchaseOption"
                  :key="purchaseOption.id"
                  v-for="purchaseOption in purchaseOptions.data"
                  :include-option-description="true"
          />
          <p class="currency-disclaimer">
            {{$t('subscription.currency_disclaimer', {currency_description: showCurrency.description, currency_code: showCurrency.code, currency_symbol: showCurrency.symbol})}}
          </p>
          <p
            v-if="upgrade"
            class="currency-disclaimer"
          >
            {{$t('subscription.upgrade_disclaimer')}}
          </p>
        </div>
      </section>
    </template>
  </LayoutPurchase>
</template>

<script>
import LayoutPurchase from "../../layouts/LayoutPurchase";

import Spinner from "../../components/Spinner";
import SubscriptionForm from "../../components/Checkout/SubscriptionForm";
import PurchaseOptionLegals from "../../components/PurchaseOptionLegals";

import resources from "../../resources";

let promotionalCodeTypedTimeout = null;

export default {
  components: {
    PurchaseOptionLegals,
    SubscriptionForm,
    LayoutPurchase,
    Spinner,
  },
  props: {
    selectedCountry: {
      required: true,
      default: null,
    },
    showCurrency: {
      required: true,
      default: null,
    },
    countries: {
      required: true,
      type: Object,
      default: {
        data: [],
        loading: true,
        error: false,
      },
    },
  },
  data() {
    return {
      promotionalCodeTyped: this.$route.query.code || "",
      promotionalCodeEntered: this.$route.query.code || "",
      suscriptionPlanIdEntered: this.$route.query.plan || "",
      webstarIdEntered: this.$route.query.webstar || "",
      purchaseOptionSelected: null,
      purchaseOptions: {
        data: [],
        loading: true,
        error: false,
      },
      fullLoading: false,
      upgrade: false,
      persistPurchaseOptions: false,
      shouldDisplayPlanDescription: false,
      planDescription: "",
    };
  },
  computed: {
    referalCode() {
      return this.$route.query.ref || null;
    },
    promotionalCode() {
      return this.promotionalCodeEntered || this.$route.query.code || null;
    },
    promotionalCodeHidden() {
      return (
        this.$route.query.code ||
        this.purchaseOptionSelected ||
        this.referalCode ||
        this.suscriptionPlanIdEntered ||
        this.webstarIdEntered
      );
    },
  },
  methods: {
    purchaseOptionSelectedChangedHandler(purchaseOptionSelected) {
      this.purchaseOptionSelected = purchaseOptionSelected;
    },
    enterPromotionalCode() {
      this.promotionalCodeEntered = this.promotionalCodeTyped;

      window.scrollTo(0, this.$refs.scrollOnNewCodeElement.offsetTop);
    },
    loadPurchaseOptions() {
      this.purchaseOptions = {
        data: [],
        error: false,
        loading: true,
      };

      resources.purchaseOptions
        .index({
          country_id: this.selectedCountry ? this.selectedCountry.id : "INT",
          include: [
            "subscription_plan.payment_methods",
            "subscription_plan.onward_subscription_plan",
            "subscription_plan.one_click_pay_cards",
          ],
          code: this.promotionalCode,
          referal: this.referalCode,
          plan: this.suscriptionPlanIdEntered,
          webstar: this.webstarIdEntered,
        })
        .then((response) => {
          const data = response.data.data.filter((purchaseOption) => {
            return purchaseOption.subscription_plan.data.is_subscription;
          });

          this.purchaseOptions = {
            data: data,
            error: false,
            loading: false,
          };
          this.checkAlreadySubscribed();
        })
        .catch((err) => {
          this.purchaseOptions = {
            data: [],
            error: true,
            loading: false,
          };
        });
    },
    checkAlreadySubscribed() {
      let upgrade = false;
      let redirect = false;
      this.purchaseOptions.data.forEach((purchaseOption) => {
        if (
          purchaseOption.promotional_code &&
          purchaseOption.promotional_code.data.type_is_pre_paid
        )
          console.log("continue");
        let followingModelType =
          purchaseOption.subscription_plan.data.current_status;
        // console.log(followingModelType);
        if (
          followingModelType === "normal" &&
          purchaseOption.subscription_plan.data.premium
        )
          upgrade = true;
        if (followingModelType === "premium") redirect = true;
      });
      // console.log({upgrade}, {redirect})
      if (redirect) this.$router.push({ name: "home" });
      if (upgrade) this.upgrade = true;
    },
    handlePersistPurchaseOptions() {
      if (this.persistPurchaseOptions) return;
      if (
        this.countries.loading ||
        this.purchaseOptions.loading ||
        this.fullLoading
      )
        return;

      this.persistPurchaseOptions = true;
    },
  },
  watch: {
    promotionalCodeTyped(codeTyped) {
      if (promotionalCodeTypedTimeout) {
        clearTimeout(promotionalCodeTypedTimeout);
      }

      if (!codeTyped) {
        this.enterPromotionalCode();
      } else {
        promotionalCodeTypedTimeout = setTimeout(() => {
          if (this.promotionalCode !== codeTyped) {
            this.enterPromotionalCode();
          }
        }, 1000);
      }
    },
    promotionalCode() {
      if (!this.countries.error || !this.countries.loading) {
        this.loadPurchaseOptions();
      }
    },
    countries: {
      handler() {
        this.handlePersistPurchaseOptions();
      },
      immediate: true,
    },
    purchaseOptions: {
      handler(data) {
        this.handlePersistPurchaseOptions();

        if (
          this.suscriptionPlanIdEntered &&
          data &&
          data.data &&
          data.data[0] &&
          data.data[0].subscription_plan.data
        ) {
          const plan = data.data[0].subscription_plan.data;

          if (plan.is_webstars_plan && !plan.is_legacy_plus_webstar) {
            this.planDescription = plan.description || "";
          } else {
            this.planDescription = plan.description_invoice || "";
          }

          this.shouldDisplayPlanDescription =
            this.planDescription && this.planDescription !== "";
        }
      },
      immediate: true,
    },
    fullLoading: {
      handler() {
        this.handlePersistPurchaseOptions();
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../styles/variables";
@import "../../styles/classes";

.error {
  text-align: center;
}

.subscription-container {
  min-height: 400px;

  .description-container {
    margin-bottom: 1em;

    .description {
      font-size: 1.5em;
      text-align: center;
    }
  }
}

section.disclaimers {
  display: block;
  text-align: center;
  margin-top: 2em;
  margin-bottom: 2em;

  .logo {
    display: block;
    margin: auto;
    height: 50px;
    width: 100%;
    background-image: var(--img-logo);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    margin-bottom: 20px;
  }

  .list {
    font-size: 1em;
    font-weight: bold;
  }
}

.promotional-code-form {
  @extend %fresh-btn;
  max-width: 15em;
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  padding: 0.25em 1.5em;
  font-size: 1.5em;
  position: relative;

  label {
    font-size: 0.75em;
  }

  input {
    display: block;
    transition: height 0.33s ease;
    height: 0;
    margin: 0;
    width: 100%;
    text-transform: uppercase;
    color: #ffffff;
    font-size: 1.25em;
    border: none;
    background-color: transparent;

    &.not-empty,
    &:focus {
      outline: none;
      height: 1.25em;
    }
  }
}
</style>
